import { Position } from "geojson";
import { PointLike } from "mapbox-gl";

import { GaiaMapMarker } from "~/modules/map/components/GaiaMapMarker";

import { AREA_MARKER_OFFSET_HOVER_EXPANDED } from "../map-layers/AreasLayerV2";
import { GaiaExpandableMapMarkerArea, GaiaExpandableMapMarkerAreaProps } from "./index";

type GaiaMapMarkerAreaOnMapProps = Omit<GaiaExpandableMapMarkerAreaProps, "disabled"> & {
    coordinates: Position;
    onMouseLeave?: () => void;
    offset?: PointLike;
    disabled: boolean;
};

export function GaiaMapExpandableMarkerAreaOnMap({
    coordinates,
    onMouseLeave,
    offset = AREA_MARKER_OFFSET_HOVER_EXPANDED,
    area,
    possibleAdjacentVisits,
    areaNameHref,
    onVisitAdd,
    disabled,
    error,
}: GaiaMapMarkerAreaOnMapProps) {
    return (
        <GaiaMapMarker coordinates={coordinates} onMouseLeave={onMouseLeave} offset={offset}>
            <GaiaExpandableMapMarkerArea
                area={area}
                areaNameHref={areaNameHref}
                possibleAdjacentVisits={possibleAdjacentVisits}
                onVisitAdd={onVisitAdd}
                disabled={disabled}
                error={error}
            />
        </GaiaMapMarker>
    );
}
